import React from 'react';
import CountUp from 'react-countup';


const FunfactSection = (props) => {

    return (
        <section className="fanfact pt-85 pb-125">
            <div className="container">
                <div className="row mt-none-30">
                    <div className="col-lg-4 col-md-4 mt-30">
                        <div className="ap-fanfact-item wow fadeInUp text-center" data-wow-delay="0ms" data-wow-duration="600ms">
                            <h2 className="xb-item--number"><CountUp end={7.8} enableScrollSpy />K+</h2>
                            <span className="xb-item--text">Happy Clients</span>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 mt-30">
                        <div className="ap-fanfact-item ap-fanfact-item--middle wow fadeInUp text-center p-0" data-wow-delay="200ms" data-wow-duration="600ms">
                            <h2 className="xb-item--number"><CountUp end={5.8} enableScrollSpy />K</h2>
                            <span className="xb-item--text">Solutions Offered</span>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 mt-30">
                        <div className="ap-fanfact-item ap-fanfact-item--middle wow fadeInUp text-center" data-wow-delay="300ms" data-wow-duration="600ms">
                            <h2 className="xb-item--number"><CountUp end={11} enableScrollSpy />K</h2>
                            <span className="xb-item--text ">Printer Sales</span>
                        </div>
                    </div>
                </div>
            </div>
            <span id="counter" className='d-none' />
        </section>
    );
}

export default FunfactSection;